import React from "react";
import firebaseApp from "../index";
import { getFirestore, updateDoc, doc } from "firebase/firestore";
import { useAppContext } from "../context/ContextProvider";
const ListadoTareas = ({ arrayTareas, setArrayTareas }) => {
    const { correoUsuario } = useAppContext();
    const firestore = getFirestore(firebaseApp);
    async function eliminarTarea(idTareaAEliminar) {
        // crear nuevo array de tareas
        const nvoArrayTareas = arrayTareas.filter(
            (objetoTarea) => objetoTarea.id !== idTareaAEliminar
        );
        // actualizar base de datos
        const docuRef = doc(firestore, `usuarios/${correoUsuario}`);
        updateDoc(docuRef, { tareas: [...nvoArrayTareas] });
        //actualizar state
        setArrayTareas(nvoArrayTareas);
    }
    return (
        <table className="table-auto hover:table-fixed bg-gray-800 p-2 my-2 border-collapse ">
            {arrayTareas.length !== 0 ? (
                <thead>
                    <tr>
                        <th className="border border-slate-600 bg-slate-900">
                            Descripción
                        </th>
                        <th className="border border-slate-600 bg-slate-900">
                            Vencimiento
                        </th>
                        <th className="border border-slate-600 bg-slate-900">
                            Eliminar
                        </th>
                    </tr>
                </thead>
            ) : (
                <h1 className="text-xl p-2">
                    ¡Felicitaciones! no tienes tareas pendientes
                </h1>
            )}

            {arrayTareas.map((objetoTarea) => {
                return (
                    <>
                        <tbody>
                            <td className="border border-slate-600">
                                {objetoTarea.descripcion}
                            </td>
                            <td className="border border-slate-600">
                                {objetoTarea.vencimiento}
                            </td>
                            <td className="border border-slate-600">
                                <button
                                    onClick={() =>
                                        eliminarTarea(objetoTarea.id)
                                    }
                                    className="text-white bg-red-600 border-0 p-2 m-2 w-10 focus:outline-none hover:bg-indigo-600 rounded text-lg"
                                >
                                    X
                                </button>
                            </td>
                        </tbody>
                    </>
                );
            })}
        </table>
    );
};

export default ListadoTareas;
